// Communication Management copy of NotifyStudentModal (BranchModal).
// Same props / data / handlers as the original — only the layout (single-row
// Branch/Class/Section) and styling change (reuses the .comm-pn-modal theme).
// Separate file so the standalone Notify Students module is unaffected.

import React, { Component } from 'react';
import { components } from 'react-select';
import Select from 'react-select';
import { Col, Form, Modal } from 'react-bootstrap';
import MultiSelect from "react-multi-select-component";
import TextEditor from '../../text_editor/TextEditor';
import '../../settings/notifystudent/_notifystudent.scss';
import './_commParentNotification.scss';

import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../../utils/authHelper";

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const classSelectStyles = {
    control: (base) => ({ ...base, minHeight: 42 }),
    option: (provided, state) => ({ ...provided, color: state.isSelected ? "white" : "black" }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
};

class CommNotifyStudentModal extends Component {
    getClasses() {
        let returnArray = [{ value: "0", label: "Select All" }];
        const classList = this.props.classes || (this.props.globals && this.props.globals.classes) || [];
        const authorizedClasses = filterByAuthorizedIds(
            classList,
            getAuthorizedClassIds(),
            "id"
        );
        authorizedClasses.forEach((item) => {
            if (item != undefined) returnArray.push({ value: item.id, label: item.class });
        });
        return returnArray;
    }

    render() {
        const branchesData = this.props.branches || [];
        const selectedBranchIds = (this.props.stateData.branch || []).map(String);
        const selectedClass = this.props.stateData.classname;

        // DATA-ENTRY: these branches are saved as branch_ids on the notification, so
        // the multi-select stays on the form. The header only narrows the options.
        let branchArray = [];
        branchesData.forEach((b) => branchArray.push({ value: b.id, label: b.branch_name }));
        const branchselectall = branchArray.length > 0;
        const branchdisableSearch = branchArray.length === 0;
        const branchlabelledBy = branchArray.length > 0 ? "Select Branch" : "No Options";

        // Section options (branch's sections filtered by selected class)
        let sectionArray = [];
        if (selectedBranchIds.length > 0) {
            const seen = new Set();
            branchesData.forEach((b) => {
                if (!selectedBranchIds.includes(String(b.id))) return;
                (b.sections || []).forEach((s) => {
                    const matchesClass = !selectedClass || selectedClass == "0" || String(s.class_id) === String(selectedClass);
                    if (matchesClass && !seen.has(s.id)) {
                        seen.add(s.id);
                        sectionArray.push({ value: s.id, label: s.section_name });
                    }
                });
            });
        }
        const sectionselectall = sectionArray.length > 0;
        const secdisableSearch = sectionArray.length === 0;
        const seclabelledBy = sectionArray.length > 0 ? "Select Section" : "Select Branch first";

        // Stream options (sections of selected branches)
        let streamArray = [];
        if (selectedBranchIds.length > 0) {
            const seenStream = new Set();
            branchesData.forEach((b) => {
                if (!selectedBranchIds.includes(String(b.id))) return;
                (b.sections || []).forEach((s) => {
                    if (s.stream_id && !seenStream.has(s.stream_id)) {
                        seenStream.add(s.stream_id);
                        streamArray.push({ value: s.stream_id, label: `Stream ${s.stream_id}` });
                    }
                });
            });
        }
        const colSize = streamArray.length > 0 ? 3 : 4;

        const classValue = (this.props.stateData.classnamevalue && this.props.stateData.classnamevalue.value !== undefined)
            ? this.props.stateData.classnamevalue
            : null;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide1}
                size="lg"
                dialogClassName="ns-modal comm-pn-modal"
                aria-labelledby="comm-notify-student-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title><i className="fas fa-bullhorn" /> Send Notification to Students</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {this.props.stateData.currentStep == 5 ? (
                        <Form.Text className="form-text text-success">Notification Saved successfully</Form.Text>
                    ) : (
                        <Form.Text className="form-text text-danger">{this.props.stateData.submitError}</Form.Text>
                    )}
                    <Form className="user-notify-form">
                        <Form.Row>
                            {/* Branch / Class / Stream / Section — single row */}
                            <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="formBranch">
                                <Form.Label className="text-uppercase font-weight-bold">Branch <span className="text-danger">*</span></Form.Label>
                                <MultiSelect
                                    overrideStrings={{ "allItemsAreSelected": "All Branches", "selectSomeItems": branchlabelledBy }}
                                    disableSearch={branchdisableSearch}
                                    hasSelectAll={branchselectall}
                                    options={branchArray}
                                    value={this.props.stateData.branchvalue}
                                    onChange={(e) => this.props.handleMultipleSelectInputChange(e, "branch")}
                                    labelledBy={"Select"}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={colSize} md={6} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Class <span className="text-danger">*</span></Form.Label>
                                <Select
                                    classNamePrefix="comm-rs"
                                    styles={classSelectStyles}
                                    components={{ DropdownIndicator }}
                                    placeholder="Class"
                                    value={classValue}
                                    onChange={(opt) => this.props.parentselecthandleInputChange("classname", opt ? opt.value : "")}
                                    options={this.getClasses()}
                                    isClearable={false}
                                    isSearchable={true}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                                    menuPosition="fixed"
                                    maxMenuHeight={200}
                                />
                            </Form.Group>

                            {streamArray.length > 0 && (
                                <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="formStream">
                                    <Form.Label className="text-uppercase font-weight-bold">Stream</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{ "allItemsAreSelected": "All Streams", "selectSomeItems": "Stream" }}
                                        options={streamArray}
                                        value={this.props.stateData.streamvalue || streamArray}
                                        onChange={(e) => this.props.handleMultipleSelectInputChange(e, "stream")}
                                        labelledBy={"Select"}
                                    />
                                </Form.Group>
                            )}

                            <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="formSection">
                                <Form.Label className="text-uppercase font-weight-bold">Section <span className="text-danger">*</span></Form.Label>
                                <MultiSelect
                                    overrideStrings={{ "allItemsAreSelected": "All Sections", "selectSomeItems": seclabelledBy }}
                                    disableSearch={secdisableSearch}
                                    hasSelectAll={sectionselectall}
                                    options={sectionArray}
                                    value={this.props.stateData.sectionvalue}
                                    onChange={(e) => this.props.handleMultipleSelectInputChange(e, "section")}
                                    labelledBy={"Select"}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="formTitle">
                                <Form.Label className="text-uppercase font-weight-bold">Title <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Title"
                                    onChange={this.props.ParenthandleInputChange}
                                    autoComplete="off"
                                    name="title"
                                    value={this.props.stateData.title}
                                />
                                <Form.Text className="form-text text-danger">{this.props.stateData.formErrors.title}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="formMessage">
                                <Form.Label className="text-uppercase font-weight-bold">Message <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Message"
                                    onChange={this.props.ParenthandleInputChange}
                                    autoComplete="off"
                                    name="message"
                                    value={this.props.stateData.message}
                                />
                                <Form.Text className="form-text text-danger">{this.props.stateData.formErrors.message}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={12} md={12} sm={12} controlId="formImage">
                                <Form.Label className="text-uppercase font-weight-bold">File (PDF / Image) <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    accept="application/pdf,image/*"
                                    onChange={this.props.ParenthandleInputChange}
                                    className="form-control-file"
                                />
                                <Form.Label className="text-uppercase">{this.props.stateData.image_filename}</Form.Label>
                                {this.props.stateData.error && (<div className="text-danger">{this.props.stateData.error}</div>)}
                            </Form.Group>

                            <Form.Group as={Col} lg={12} md={12} sm={12} controlId="formLong">
                                <Form.Label className="text-uppercase font-weight-bold">Long Description <span className="text-danger">*</span></Form.Label>
                                <TextEditor handleEditorChange={this.props.handleEditorChange} />
                                <Form.Text className="form-text text-danger">{this.props.stateData.formErrors.ldescription}</Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button className="pn-modal-submit" onClick={this.props.parenthandleFormSubmit}>
                        <i className="fas fa-paper-plane" /> Send Notification
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CommNotifyStudentModal;
